import styled from 'styled-components'
import { Header, Copy, Link, Button, StandardCard, theme } from '@navinc/base-react-components'
import { Main } from './styled'
import { useTerms } from '../hooks/apollo/use-terms'
import { usePartner } from '../hooks/apollo/use-partner'
import { useAcceptTerms } from '../hooks/apollo/use-accept-terms'
import { usePartnerConfig } from '../hooks/use-partner-config'

const Wrapper = styled.div`
  width: 100%;
`

const LogoWrapper = styled.div`
  background-color: ${theme.white};
  border-bottom: solid 1px ${theme.neutral300};
  display: flex;
  justify-content: center;
  width: 100%;
`

const Image = styled.img`
  margin-top: 8px;
  margin-bottom: 8px;
`

const InputWrappers = styled.div`
  margin-left: auto;

  & > * {
    margin-right: 16px;
  }
`

const TermsWrapper = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: baseline;

  @media (${theme.forLargerThanPhone}) {
    flex-flow: column;
  }

  & > * {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  & > ${Copy} {
    @media (${theme.forLargerThanPhone}) {
      width: 500px;
    }
  }
`

export const Terms = ({ children }) => {
  const { getLogoURL } = usePartner()
  const logoURL = getLogoURL()

  const {
    configurations: { showMainTermsComponent },
  } = usePartnerConfig()
  const {
    consentToTerms,
    termsAvailability: { isAvailable: dataSharingIsEligible, termsURL: dataSharingTermsURL } = {},
  } = useTerms()

  const [acceptTerms, { data, loading: isAcceptTermsLoading }] = useAcceptTerms({ variables: { consent: true } })

  const hasAcceptedTerms = data?.consentToTerms?.ok
  const shouldShowTerms = !consentToTerms && !!dataSharingIsEligible && !hasAcceptedTerms && showMainTermsComponent

  if (shouldShowTerms) {
    return (
      <Wrapper>
        <LogoWrapper>
          <Image src={logoURL} />
        </LogoWrapper>
        <Main>
          <StandardCard>
            <TermsWrapper>
              <Header>Welcome!</Header>
              <Copy>
                By clicking on "Continue", you agree to the{' '}
                <Link target="_blank" href={dataSharingTermsURL}>
                  Terms of Use.
                </Link>
              </Copy>
              <InputWrappers>
                <Button
                  onClick={() => {
                    acceptTerms({
                      variables: {
                        consent: true,
                      },
                    })
                  }}
                  isLoading={isAcceptTermsLoading}
                >
                  Continue
                </Button>
              </InputWrappers>
            </TermsWrapper>
          </StandardCard>
        </Main>
      </Wrapper>
    )
  }

  return children
}
